import React from 'react';
import { MobileOnlyMenu } from './MobileOnlyMenu';
import { Search } from './Search';
import { VerticalMenu } from './VerticalMenu';
import { LeftPanelType } from '../../models/api/codegen/code';
import { getLeftPanel } from '../../spirsApi/api-client';
import { ReactComponent as CloseIcon } from '../icons/close.svg';
import clsx from 'clsx';
import { ShowBalance } from '../balance/ShowBalance';

interface VerticalMenuProps {
    toggleVerticalMenu: () => void;
    isOpen: boolean;
}

export const Menu: React.FC<VerticalMenuProps> = ({
    toggleVerticalMenu,
    isOpen
}) => {
    const [leftPanel, setLeftPanel] = React.useState<LeftPanelType | undefined>(
        undefined
    );

    React.useEffect(() => {
        getLeftPanel().then(data => {
            if (!data) {
                return;
            }
            setLeftPanel(data);
        });
    }, []);


    React.useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!leftPanel) {
        return <></>;
    }

    return (
        <>
            <nav
                className={clsx(
                    'w-[240px] pb-[58px] flex flex-col overflow-y-auto bg-[#171A1E] max-tablet:fixed max-tablet:top-0 max-tablet:left-0 h-full max-tablet:z-[999]',
                    !isOpen ? 'max-tablet:hidden' : ''
                )}
            >
                <div
                    className="hidden px-[10px] py-[8px] max-tablet:block"
                    onClick={toggleVerticalMenu}
                >
                    <CloseIcon />
                </div>
                <div className='max-tablet:hidden'>
                    <ShowBalance />
                </div>
                {leftPanel.showSearch && (
                    <Search toggleVerticalMenu={toggleVerticalMenu} />
                )}
                {leftPanel.showMobileMenu && (
                    <MobileOnlyMenu toggleVerticalMenu={toggleVerticalMenu} />
                )}
                <div className="overflow-y-auto flex-1 min-h-0" style={{scrollbarWidth: "none"}}>
                    <VerticalMenu
                        toggleVerticalMenu={toggleVerticalMenu}
                        leftPanel={leftPanel}
                    />
                </div>
            </nav>
            <div className={clsx(
                    'w-full h-full overflow-y-hidden max-tablet:fixed max-tablet:top-0 max-tablet:left-0 max-tablet:z-[998]',
                    !isOpen ? 'hidden' : 'netbook:hidden'
                )} style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} onClick={toggleVerticalMenu}></div>
        </>
    );
};
